import axios from 'axios'

const baseURL = process.env.VUE_APP_API_NODE_URL

const axiosNodeInstance = axios.create({
  baseURL: `${baseURL}/api/`
})

axiosNodeInstance.defaults.headers.common.Accept = 'application/json'

export default axiosNodeInstance
